import { noAutofill } from '../../utils/noAutofill';

const FIELD_STYLE = {
  border: '1px solid rgba(139,69,19,0.15)', borderRadius: '8px',
  padding: '8px 12px', fontSize: '13px', color: '#2b2b2b',
  fontFamily: 'inherit', outline: 'none', background: '#fdfcfb',
  width: '100%', boxSizing: 'border-box', transition: 'border-color 0.15s',
};

function Field({ label, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <label style={{ fontSize: '10.5px', fontWeight: '700', color: '#8B4513', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {label}
      </label>
      {children}
    </div>
  );
}

function TextInput({ value, onChange, placeholder, type = 'text' }) {
  return (
    <input type={type} value={value} placeholder={placeholder} {...noAutofill}
      onChange={e => onChange(e.target.value)} style={FIELD_STYLE}
      onFocus={e => { e.target.style.borderColor = '#8B4513'; }}
      onBlur={e  => { e.target.style.borderColor = 'rgba(139,69,19,0.15)'; }} />
  );
}

export default function EstimateForm({ estimate, onChange }) {
  function update(field, value) { onChange({ ...estimate, [field]: value }); }

  return (
    <div style={{ background: 'white', borderRadius: '14px', border: '1px solid rgba(139,69,19,0.1)', boxShadow: '0 4px 20px rgba(139,69,19,0.07)', overflow: 'hidden', marginBottom: '24px' }}>
      <div style={{ padding: '12px 20px', background: 'linear-gradient(135deg, #8B4513 0%, #A0522D 100%)', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '18px' }}>📝</span>
        <div>
          <div style={{ color: 'white', fontWeight: '700', fontSize: '14px' }}>Customer Information</div>
          <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '11px' }}>Estimate details and contact info</div>
        </div>
      </div>
      <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '14px' }}>
          <Field label="Customer Name"><TextInput value={estimate.customerName} onChange={v => update('customerName', v)} placeholder="Full name..." /></Field>
          <Field label="Phone"><TextInput value={estimate.phone} onChange={v => update('phone', v)} placeholder="(605) 000-0000" type="tel" /></Field>
          <Field label="Estimate Date"><TextInput value={estimate.date} onChange={v => update('date', v)} type="date" /></Field>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr', gap: '14px' }}>
          <Field label="Street Address"><TextInput value={estimate.address} onChange={v => update('address', v)} placeholder="123 Main St..." /></Field>
          <Field label="City"><TextInput value={estimate.city} onChange={v => update('city', v)} placeholder="Milbank" /></Field>
          <Field label="State / Zip"><TextInput value={estimate.stateZip} onChange={v => update('stateZip', v)} placeholder="SD 57252" /></Field>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 2fr', gap: '14px' }}>
          <Field label="Contact Date"><TextInput value={estimate.contactDate} onChange={v => update('contactDate', v)} type="date" /></Field>
          <Field label="Email"><TextInput value={estimate.email} onChange={v => update('email', v)} placeholder="customer@email.com" type="email" /></Field>
          <Field label="Job / Project Name"><TextInput value={estimate.jobName} onChange={v => update('jobName', v)} placeholder="Kitchen remodel..." /></Field>
        </div>
        <Field label="Comments / Notes (printed on estimate)">
          <textarea value={estimate.comments} onChange={e => update('comments', e.target.value)} {...noAutofill}
            placeholder="Any notes to include on the estimate for the customer..."
            rows={3} style={{ ...FIELD_STYLE, resize: 'vertical', lineHeight: '1.5' }}
            onFocus={e => { e.target.style.borderColor = '#8B4513'; }}
            onBlur={e  => { e.target.style.borderColor = 'rgba(139,69,19,0.15)'; }} />
        </Field>
      </div>
    </div>
  );
}
